/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { MerchantResponse } from '../../models/merchant-response';

export interface GetMerchantById$Params {
  merchantId: string;
}

export function getMerchantById(http: HttpClient, rootUrl: string, params: GetMerchantById$Params, context?: HttpContext): Observable<StrictHttpResponse<MerchantResponse>> {
  const rb = new RequestBuilder(rootUrl, getMerchantById.PATH, 'get');
  if (params) {
    rb.path('merchantId', params.merchantId, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/hal+json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<MerchantResponse>;
    })
  );
}

getMerchantById.PATH = '/merchants/{merchantId}';
